/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_SubmittingInputs */

const vi_sl_new_submitting = /** @type {(inputs: Sl_New_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tạo...`)
};

/**

* @param {Sl_New_SubmittingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_submitting = /** @type {((inputs?: Sl_New_SubmittingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_SubmittingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_submitting(inputs)
});